import axios from "axios";

export const TERMINAL_URL = "/api/terminal";

export function findTerminalInfo(terminalStockId) {
  return axios.get(`${TERMINAL_URL}/getByTerminalStock/${terminalStockId}`);
}
